import React, { useEffect, useState } from 'react';
import { Text } from '@fluentui/react/lib/Text';
import useSystemCall from '../../../common/custom-hooks/useSystemCall';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Icon, Spinner, SpinnerSize } from '@fluentui/react';
import { defenseFileAssistantDropdownValues, routes } from '../../../common/constants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Ending = (props: any) => {
  const { t } = useTranslation();
  const [defenseFileResponse, setDefenseFileResponse] = useState<any>();
  const [defenseFileById, setDefenseFileById] = useState<any>();
  const [isGenerating, setIsGenerating] = useState(false);
  const navigate = useNavigate();

  const GetDefenseFile = useSystemCall(props.system, (system) =>
      props.system && defenseFileResponse && defenseFileResponse.id
          ? props.system.defenseFileSystem.getById(defenseFileResponse.id)
          : null
  );

  useEffect(() => {
    if (defenseFileResponse) {
      setDefenseFileById(defenseFileResponse);
    }
  }, [GetDefenseFile, defenseFileResponse]);

  const handleFinalize = async () => {
    if (defenseFileResponse) {
      navigate(`${routes.defense_file}/${defenseFileResponse.id}`);
      return;
    }
    if (!props.data) return;

    setIsGenerating(true);
    try {
      const response =
          props.type === defenseFileAssistantDropdownValues.forProjects
              ? await props.system.defenseFileSystem.generateForProjects(
                  props.data.fromDate,
                  props.data.toDate,
                  props.data.company,
                  props.data.activityReport,
                  props.data.selectedProjectsId,
                  props.data.requirementData
              )
              : await props.system.defenseFileSystem.generateForSettlements(
                  props.data.fromDate,
                  props.data.toDate,
                  props.data.company,
                  props.data.activityReport,
                  props.data.selectedProjectsId,
                  props.data.requirementData
              );
      setDefenseFileResponse(response);
      if (props.courier) {
        props.courier.messageSuccess(t('Se ha generado el archivo de defensa'));
      }
    } catch (e) {
      if (props.courier) {
        props.courier.messageError(e);
      }
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="padding-1">
      {defenseFileResponse ? (
        <>
          <Text>
            <Icon
              iconName="CheckMark"
              className="text-icon success-color"
            ></Icon>
            {t("Se ha generado el archivo de defensa ") +
              (defenseFileResponse ? defenseFileResponse.id : null)}
          </Text>

          <br />
        </>
      ) : null}
      <div className="ms-Grid-col  ms-sm12 mt-2">
        <Icon iconName="Warning"></Icon>
        {t(" AVISO: Se notificará por correo cuando el proceso finalice.")}
      </div>
      {defenseFileResponse ? null : (
        <PrimaryButton
          className="mt-2"
          onClick={handleFinalize}
          disabled={isGenerating || (!defenseFileResponse && !props.data)}
        >
          {isGenerating ? <Spinner size={SpinnerSize.small} /> : t("Finalizar")}
        </PrimaryButton>
      )}
    </div>
  );
};

export default Ending;
